<div class="stroked-btn-icon-left btn-with-theme" [ngClass]="theme">
    <button mat-stroked-button class="btn"
    [type]="type" 
    [ngClass]="{'uc': uppercase, 'primary-color': color == 'primary'}" 
    [color]="color" 
    [disabled]="disabled" 
    [ngStyle]="{'fontWeight': fontWeight}"
    >
        <div class="btn-icon-text-wrapper">
            {{iconPosition == 'right' ? text : ''}}
            <div class="btn-icon-wrapper">
                <mat-icon class="material-icons-outlined btn-icon" [color]="iconColor">{{icon}}</mat-icon>
            </div>
            {{iconPosition == 'left' ? text : ''}}
        </div>
    </button>
</div>
